var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seat-button",class:{active: _vm.clicked},on:{"click":_vm.toggleSeat}},[_c('div',{staticClass:"seat-status-icon"},[_vm._v("\n        "+_vm._s(_vm.seatNum)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }